const styles = {
  container: {
    position: 'absolute',
    left: '80px',
    top: '15px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  mediumText: {
    fontSize: '14px',
    color: '#ffffff',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
  },
  smallItalicText: {
    fontSize: '12px',
    color: '#ffffff',
    fontStyle: 'italic',
  },
  dropDownWrapper: {
    position: 'relative',
  },
  dropdownContainerHidden: {
    display: 'none',
  },
  dropdownContainerOpened: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    backgroundColor: 'white',
    position: 'absolute',
    width: '100%',
  },
  dropdownItem: {
    fontSize: '14px',
    color: '#939BA9',
    padding: '8px',
    borderBottom: '1px solid hsla(218, 11%, 62%, 0.12)',
    width: '100%',
    textAlign: 'left',
  },
  arrowDown: {
    border: 'solid white',
    borderWidth: ' 0 1px 1px 0',
    display: 'inline-block',
    padding: '2px',
    transform: 'translate(0,-1px) rotate(45deg)',
    marginLeft: '8px',
  },
  arrowUp: {
    border: 'solid white',
    borderWidth: ' 0 1px 1px 0',
    display: 'inline-block',
    padding: '2px',
    transform: 'translate(0,1px) rotate(-135deg)',
    marginLeft: '8px',
  },
}

export default styles
